import Model from './Model';

export default class extends Model {
  async get() {
    let url = '/transactions?' + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-transactions'
      )
    );
  }
}
